module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      backgroundImage: _vm.linearGradient
    }),
    attrs: {
      "id": "ui-slider"
    }
  }, [_c('div', {
    staticClass: "color-picker__handle ui-slider-handle",
    style: ({
      backgroundColor: _vm.color
    })
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d765fc2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d765fc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/color-picker.vue
// module id = 53
// module chunks = 1